import moment from 'moment'

import { isSameDay } from '../../../utils/helpers'
import styles from './DateDivider.module.scss'

const DateDivider = ({ prevMessage, currentMessage }) => {
  const prevDate = prevMessage
    ? prevMessage.finalizedOn || prevMessage.sentOn || prevMessage.scheduledOn
    : null
  const currentDate =
    currentMessage.finalizedOn || currentMessage.sentOn || currentMessage.scheduledOn

  if (isSameDay(prevDate, currentDate)) {
    return null
  } else {
    return (
      <div className={styles.container}>
        <div className={styles.divider}>
          <span>{moment(currentDate).format('dddd, MMM DD, yyyy')}</span>
        </div>
      </div>
    )
  }
}

export default DateDivider
